import { render, staticRenderFns } from "./ComponentDetailsModal.vue?vue&type=template&id=33705af2&scoped=true&"
import script from "./ComponentDetailsModal.vue?vue&type=script&lang=js&"
export * from "./ComponentDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./ComponentDetailsModal.vue?vue&type=style&index=0&id=33705af2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33705af2",
  null
  
)

export default component.exports